export const groupPerguntasByCategoria = (perguntas, ignoreResposta_texto_final = false) => {
    let grouped = {}

    perguntas.forEach(pergunta => {
        const ignore = ignoreResposta_texto_final && String(pergunta.resposta_texto_final) === '0'
        if (!ignore) {
            const categoriaId = pergunta.categoria_pergunta_id
            if (grouped[categoriaId]) {
                const currentPerguntas = grouped[categoriaId].perguntas
                grouped[categoriaId] = {
                    ...grouped[categoriaId],
                    perguntas: [...currentPerguntas, pergunta]
                }
            } else {
                const newItem = { ...pergunta.categoria_pergunta, perguntas: [pergunta] }
                grouped[categoriaId] = newItem
            }
        }
    })

    return Object.values(grouped)
}

export const groupPerguntasBySecao = (perguntas, ignoreResposta_texto_final = false) => {
    const grouped = {};

    perguntas.forEach(pergunta => {
        const ignore = ignoreResposta_texto_final && String(pergunta.resposta_texto_final) === '0';
        if (ignore) return;

        const categoria = pergunta.categoria_pergunta;
        const secao = categoria.secao_categoria;

        if (!secao) return;

        const secaoId = secao.id;
        const categoriaId = categoria.id;

        if (!grouped[secaoId]) {
            grouped[secaoId] = {
                ...secao,
                movimentos: {}
            };
        }

        if (!grouped[secaoId].movimentos[categoriaId]) {
            grouped[secaoId].movimentos[categoriaId] = {
                ...categoria,
                perguntas: []
            };
        }

        grouped[secaoId].movimentos[categoriaId].perguntas.push(pergunta);
    });

    const result = Object.values(grouped).map(secao => ({
        ...secao,
        movimentos: Object.values(secao.movimentos)
    }));

    return result;
};


export const getCheckedPerguntasIds = (respostas) => {
    const perguntasIds = Object.keys(respostas)
    return perguntasIds.filter(perguntaId => {
        return respostas?.[perguntaId]?.checked && respostas?.[perguntaId]?.answered
    })
}

export const removeTags = (html) => {
    let div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    return text.trim()
}

export const extractPerguntasFromSecoes = (secoes = []) => {
      secoes
    .flatMap(secao => secao.movimentos || [])
    .flatMap(categoria => categoria.perguntas || []);
}